export default "__VITE_ASSET__DAQqTEJW__"